import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CategoryLevel } from '../model/competitions/Level';
import { CompetitionService } from './competition.service';
import { AdministratorEntity } from '../model/administrator/AdministratorEntity';
import { AcademyAdministratorOperation } from '../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../model/administrator/AcademyAdministratorType';
import { Modalidad } from '../model/Modalidad';
import { QueryOptionDto } from '../model/QueryOptionDto';

@Injectable({
  providedIn: 'root'
})
export class CategoryLevelService {

  constructor(private competitionService: CompetitionService) { }

  getAllCategoryLevels(modality?: Modalidad): Observable<any> {
    const options: QueryOptionDto | null = modality ? {
      options: {
        conditionals: [
          {
            conditionalConnector: 'AND',
            logicOperator: '=',
            evaluatedProperty: 'modality',
            parameterName: '@ModalidadSelected',
            parameterValue: modality,
          },
        ],
      },
    } : null;

    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.SELECT,
      payload: options,
      type: AcademyAdministratorType.LEVELS,
    };
    return this.competitionService.sendRequest(entity);
  }

  createCategoryLevel(categoryLevel: CategoryLevel): Observable<any> {
    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.CREATE,
      payload: categoryLevel,
      type: AcademyAdministratorType.LEVELS,
    };
    return this.competitionService.sendRequest(entity);
  }

  updateCategoryLevel(categoryLevel: CategoryLevel): Observable<any> {
    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.UPDATE,
      payload: categoryLevel,
      type: AcademyAdministratorType.LEVELS,
    };
    return this.competitionService.sendRequest(entity);
  }

  deleteCategoryLevel(categoryLevel: CategoryLevel): Observable<any> {
    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.DELETE,
      payload: categoryLevel,
      type: AcademyAdministratorType.LEVELS,
    };
    return this.competitionService.sendRequest(entity);
  }
}